import {Injectable} from '@angular/core';
import {DocumentModel} from '../models/document.model';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {ActionModel} from '../models/action.model';
import {CleanUpDocumentBeanService} from './clean-up-document-bean.service';
import {LokijsService} from './database/lokijs.service';
import {ModalController} from '@ionic/angular';
import {GeneralService} from './general.service';
import {ConfigurationService} from './configuration.service';
import {UrlEndpoints} from '../definitions/url-endpoints';
import {StateManagerService} from './state-manager.service';

@Injectable({
    providedIn: 'root'
})
export class SyncActionsService {

    constructor(private modalController: ModalController,
                private http: HttpClient,
                private generalServices: GeneralService,
                private configuration: ConfigurationService,
                private urlEndPoints: UrlEndpoints,
                private cleanUpDoc: CleanUpDocumentBeanService,
                private stateManager: StateManagerService) {
    }

    async syncActions(action: ActionModel) {
        const tempAction = JSON.parse(JSON.stringify(action));
        await this.cleanUpDoc.cleanDoc(tempAction);
        await this.cleanUpDoc.cleanExtraFieldActions(tempAction);
        return new Promise<boolean>((resolve, reject) => {
            this.http.post(this.configuration.buildUrl(this.urlEndPoints.postActionEndPoint), tempAction, {
                reportProgress: true,
                observe: 'events'
            }).subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {
                    // this.progressMsg = 'Uploading action... ' + Math.round(event.loaded / event.total * 100) + '%';
                    // this.loadingMsgSubject.next(this.progressMsg);
                    // this.uploadStatus.next(event.loaded / event.total);
                } else if (event.type === HttpEventType.Response) {
                    if (event.status === 200) {
                        console.log(event);
                        console.log(tempAction);
                        this.stateManager.findAndRemove('action', action.$loki);
                        this.generalServices.createToast('Action uploaded');
                        resolve(true);
                    }
                    console.log(event);
                }
            }, error => {
                this.generalServices.createToast('Upload Failed');
                console.log(error);
                reject(false);
            });
        });
    }
}
